import React from 'react';
import './Footer.css'
import ContactLinks from './ContactLinks';
import { NavLink, Link } from 'react-router-dom';
const Footer = () => {
  return (
    <>
        <div className='footer'>
            <div className="first">
                <ul className='fot_ul'>
                    <li className="foot_list"><span>What we Provide</span></li>
                    <NavLink to="resume-maker-online"><li className="foot_list">Resume Builder</li></NavLink>
                    <NavLink to="aktu-quantum-books"><li className="foot_list">Qantum Books Pdf</li></NavLink>
                    <Link to="developer-roadmaps"><li className="foot_list">RoadMaps</li></Link>
                    <NavLink to="handwritten-notes-pdf"><li className="foot_list">Hand Written Notes</li></NavLink>
                    <Link to="projects"><li className="foot_list">Projects</li></Link>
                    <NavLink to="previous_years"><li className="foot_list">Exam Papers</li></NavLink>
                </ul>
            </div>
            <div className="second">
            <ul className='fot_ul'>
                    <NavLink to=""><li className="foot_list"><span>Blogs</span></li></NavLink>
                    <NavLink to=""><li className="foot_list">Top Blogs</li></NavLink>
                    <NavLink to=""><li className="foot_list">Top Colleges</li></NavLink>
                    <NavLink to=""><li className="foot_list">Exam News</li></NavLink>
                    <NavLink to=""><li className="foot_list">New Technology</li></NavLink>
                    <NavLink to=""><li className="foot_list">Top </li></NavLink>
                </ul>                
            </div>
            <div className="third">
            <ul className='fot_ul'>
                    <li className="foot_list"><span>About US</span></li>
                    <NavLink to="/FaqPage"><li className="foot_list">FAQ</li></NavLink>
                    <NavLink to="/Contact"><li className="foot_list">Contact Us</li></NavLink>
                    <NavLink to="/Team"><li to="/Team" className="foot_list">Founder & Website Designer</li></NavLink>
                    <Link to='/Team' className="foot_list"><span>Utkarsh Gupta</span></Link>
                    <li className="foot_list">Email : 0preperation@gmail.com</li>
                </ul>
                <div className="footer_medialinks">
                    <ContactLinks/>
                </div>
            </div>
            
        </div>
    
    
    
    </>
  )
}

export default Footer